document.addEventListener("DOMContentLoaded", function () {

  const swipers = document.querySelectorAll(".productSwiper");

  swipers.forEach(function (slider) {

    const slidesPerView = Number(slider.dataset.slides) || 2;
    const spaceBetween = Number(slider.dataset.space) || 20;
    const loop = slider.dataset.loop === "true";
    const mousewheel = slider.dataset.mousewheel === "true";
    const autoplayEnabled = slider.dataset.autoplay === "true";
    const autoplaySpeed = Number(slider.dataset.speed) || 3000;

    new Swiper(slider, {

      direction: "vertical",

      slidesPerView: slidesPerView,

      spaceBetween: spaceBetween,

      loop: loop,

      speed: 800,

      navigation: {
        nextEl: slider.querySelector(".swiper-button-next"),
        prevEl: slider.querySelector(".swiper-button-prev"),
      },

      autoplay:false,

      breakpoints: {

        0: {
          direction: "horizontal",
          slidesPerView: 2,
          spaceBetween: 10,
        },

        768: {
          direction: "vertical",
          slidesPerView: slidesPerView,
          spaceBetween: spaceBetween,
        }

      }

    });

  });

});